'use client'

import { isValidPhoneNumber } from 'libphonenumber-js'


import { MInput } from '@/_components/medante/m-input'

import { ERR } from '../_utils/patient-form.constants'

import { APatientInfoSectionHeading } from './a-patient-info-section-heading'

import type { PatientFormValues } from '../_types/patient-form.types'
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

type APatientInfoLegalGuardianSectionProps = {
	register: UseFormRegister<PatientFormValues>
	control: Control<PatientFormValues>
	errors: FieldErrors<PatientFormValues>
	isChildOrder: boolean
}

export function APatientInfoLegalGuardianSection({
	register,
	control,
	errors,
	isChildOrder
}: APatientInfoLegalGuardianSectionProps) {
	if (!isChildOrder) return null

	return (
		<section className='mb-8'>
			<APatientInfoSectionHeading>Osobné údaje zákonného zástupcu</APatientInfoSectionHeading>

			<div className='mb-3 grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-4'>
				<MInput
					label='Meno'
					required
					error={errors.parent?.firstName?.message}
					registration={register('parent.firstName', {
						required: isChildOrder ? ERR.firstName : false
					})}
				/>

				<MInput
					label='Priezvisko'
					required
					error={errors.parent?.lastName?.message}
					registration={register('parent.lastName', {
						required: isChildOrder ? ERR.lastName : false
					})}
				/>
			</div>

			<div className='grid grid-cols-1 gap-2.5 sm:grid-cols-2 sm:gap-4'>
				<MInput
					label='Email'
					type='email'
					required
					error={errors.parent?.email?.message}
					registration={register('parent.email', {
						required: isChildOrder ? ERR.email.required : false,
						pattern: {
							value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
							message: ERR.email.invalid
						}
					})}
				/>

				<MInput<PatientFormValues, 'parent.phone'>
					type='phone'
					name='parent.phone'
					control={control}
					rules={{
						required: isChildOrder ? ERR.phone.required : false,
						validate: v => {
							if (!v) return isChildOrder ? ERR.phone.required : true
							return isValidPhoneNumber(v) || ERR.phone.invalid
						}
					}}
					label='Telefonický kontakt'
					required
					error={errors.parent?.phone?.message}
				/>
			</div>
		</section>
	)
}
